import {
  Container,
  Input,
  InputContainer,
  InputLabel,
  InputError,
  Button,
  Center,
  Select,
} from "./style";

import { Formik, Field, Form, FormikHelpers, ErrorMessage } from "formik";
import { useAuth } from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useServiceUser } from "../../../hooks/serviceUser";
import { toast, ToastContainer } from "react-toastify";
import { useEffect, useMemo, useState } from "react";
import MySpaceLocationSelector from "@/components/my-space/general/MySpaceLocationSelector";

export default function MySpaceProfile() {
  const { t } = useTranslation();
  const { updateUser } = useServiceUser();
  const { user } = useAuth();
  const [documentType, setDocumentType] = useState(user?.document_type || "");
  const [documentFile, setDocumentFile] = useState<File | null>(null); // Estado local para o arquivo

  const initialValues = useMemo(() => {
    return {
      fullname: user?.fullname || "",
      email: user?.email || "",
      phone: user?.phone || "",
      document: user?.document || "",
      state_registration: user?.state_registration || "",
      password: "",
      new_password_confirm: "",
      zip_code: user?.zip_code || "",
      street: user?.street || "",
      address: user?.address || "",
      house_number: user?.house_number || "",
      complement: user?.complement || "",
      neighborhood: user?.neighborhood || "",
      federal_unity: user?.federal_unity || "",
      city: user?.city || "",
      full_address: user?.address || "",
      lat: user?.lat || "",
      lng: user?.lng || "",
      document_type: documentType,
      document_photo: user?.document_photo || "",
    };
  }, [user]);

  useEffect(() => {
    if (user) {
      console.log("Usuário carregado:", user);
    }
  }, [user]);

  useEffect(() => {
    if (user?.address === "" || user?.street === undefined) {
      initialValues.address = "";
    } else if (user?.address !== undefined) {
      return;
    } else if (user?.address === "" && user?.street !== undefined) {
      initialValues.address = `${user?.street}, ${user?.house_number}, ${user?.complement}, ${user?.neighborhood}, ${user?.city} - ${user?.federal_unity}`;
    }
  }, [initialValues]);

  const handleSubmit = async (
    values: typeof initialValues,
    actions: FormikHelpers<typeof initialValues>
  ) => {
    const data = {} as Parameters<typeof updateUser>[0];

    // Preencher dados do formulário
    data.fullname = values.fullname;
    data.phone = values.phone;
    data.address = values.full_address; // Adicionando o endereço

    // Incluir document type e o arquivo em base64
    data.document_type = documentType; // Tipo de documento selecionado
    console.log("Sending data:", data);
    if (documentFile) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result as string; // Converte para base64
        data.document_photo = base64String; // Atribui ao payload

        try {
          const response = await updateUser(data);
          toast.success(t("successfully"), {
            position: toast.POSITION.TOP_CENTER,
          });
        } catch (error) {
          toast.error((error as Error).message, {
            position: "top-right",
          });
        }
      };
      reader.readAsDataURL(documentFile);
    } else {
      // Se não houver arquivo, apenas atualiza os outros dados
      try {
        await updateUser(data);

        toast.success(t("successfully"), {
          position: toast.POSITION.TOP_CENTER,
        });
      } catch (error) {
        toast.error((error as Error).message, {
          position: "top-right",
        });
      }
    }
  };

  const formValidation = (values: typeof initialValues) => {
    if (values.password.length > 0) {
      if (values.password !== values.new_password_confirm) {
        return {
          new_password_confirm: t("password-not-equal"),
        };
      }

      // if (values.old_password.length === 0) {
      //   return {
      //     old_password: t("password-required"),
      //   };
      // }
    }

    if (values.fullname.length === 0) {
      return {
        fullname: t("field-required"),
      };
    }

    return {};
  };

  return (
    <Container>
      <ToastContainer />
      <Formik
        enableReinitialize
        validate={formValidation}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <Form>
          <InputContainer>
            <div>
              <InputLabel>{t("name")}</InputLabel>
              <Field as={Input} type="text" name="fullname" />
              <InputError>
                <ErrorMessage name="fullname" />
              </InputError>

              <InputLabel>{t("phone")}:</InputLabel>
              <Field as={Input} type="text" name="phone" />
              <InputError>
                <ErrorMessage name="phone" />
              </InputError>

              <InputLabel>CNPJ/CPF:</InputLabel>
              <Field as={Input} type="text" name="document" disabled />
              <InputError>
                <ErrorMessage name="document" />
              </InputError>

              <InputLabel hidden={user?.document_type === "cpf"}>
                {t("state-registration")}:
              </InputLabel>
              <Field
                as={Input}
                type="text"
                name="state_registration"
                style={{
                  display: `${
                    user?.document_type === "cpf" ? "none" : "block-inline"
                  }`,
                }}
              />
              <InputError>
                <ErrorMessage name="state_registration" />
              </InputError>

              <InputLabel>{t("email")}</InputLabel>
              <Field as={Input} type="email" name="email" disabled />
              <InputError>
                <ErrorMessage name="email" />
              </InputError>

              {/* <InputLabel>{t("old-password")}:</InputLabel>
                          <Field
                              as={Input}
                              type="password"
                              name="old_password"
                          /> */}
              {/* <InputError>
                              <ErrorMessage name="old_password" />
                          </InputError> */}

              <InputLabel>{t("new-password")}:</InputLabel>
              <Field as={Input} type="password" name="password" />
              <InputError>
                <ErrorMessage name="new_password" />
              </InputError>

              <InputLabel>{t("confirm-new-password")}:</InputLabel>
              <Field as={Input} type="password" name="new_password_confirm" />
              <InputError>
                <ErrorMessage name="new_password_confirm" />
              </InputError>
            </div>
            <div
              style={{
                width: "100%",
                paddingBottom: "30px",
                marginBottom: "30px",
              }}
            >
              <MySpaceLocationSelector />
              {/*<InputLabel>{t("document-type")}:</InputLabel>
                          <Field
                              as={Select}
                              name="document_type"
                              value={documentType}
                              required
                              onChange={(event:any) => {
                                  const value = event.target.value; 
                                  setDocumentType(value);
                              }}
                              style={{
                                  width: '100%',
                                  padding: '10px',
                                  borderRadius: '5px',
                                  border: '1px solid #ccc',
                                  marginBottom: '10px'
                              }}
                          >
                              <option value="cnh">{t("CNH")}</option>
                              <option value="rg">{t("RG")}</option>
                          </Field>
                          <InputError>
                              <ErrorMessage name="document_type" />
                          </InputError>
                        <InputLabel>{t("upload-document")}:</InputLabel>
                        <input
                            type="file"
                            accept=".pdf"  // Aceita apenas arquivos PDF
                            onChange={(event) => {
                                const files = event.currentTarget.files;
                                if (files && files[0]) {
                                    setDocumentFile(files[0]); 
                                }
                            }}
                            style={{
                                display: 'block',
                                margin: '10px 0',
                            }}
                        />*/}
            </div>
          </InputContainer>

          <Center>
            <Button type="submit">{t("update")}</Button>
          </Center>
        </Form>
      </Formik>
    </Container>
  );
}
